"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionType = void 0;
var InteractionType;
(function (InteractionType) {
    InteractionType["IMPRESSION"] = "IMPRESSION";
    InteractionType["CLICK"] = "CLICK";
    InteractionType["SET_PRIVACY_FLAG"] = "SET_PRIVACY_FLAG";
})(InteractionType || (exports.InteractionType = InteractionType = {}));
